
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("8jV93", function(module, exports) {
module.exports = JSON.parse('{"frozen-columns-onboarding.spotlight.body":"Sortieren und blockieren Sie Vorg\xe4nge und \xe4ndern Sie ihre Gr\xf6\xdfe \xfcber ein einziges Steuerelement.","frozen-columns-onboarding.spotlight.dismiss":"OK","frozen-columns-onboarding.spotlight.heading":"Vorg\xe4nge verwalten","jira-nin-group-by-any-field-changeboarding.spotlight.body":"Gruppieren Sie Vorg\xe4nge nach Feldern, einschlie\xdflich Versionen, Stichw\xf6rtern, Vorgangstypen und mehr.","jira-nin-group-by-any-field-changeboarding.spotlight.dismiss":"OK","jira-nin-group-by-any-field-changeboarding.spotlight.heading":"Vorg\xe4nge gruppieren f\xfcr mehr Ordnung"}');

});


//# sourceMappingURL=de.3354e188.js.map
